import bizNodeModel from '../../bizNodeModel.mjs'
import DemoType from './DemoType.mjs'

export default bizNodeModel({
    demoType: {
        disabled: (map, node) => node.data.pkid,
        name: () => '流程图类型',

        readableValue: (map, node) => {
            const {demoType} = node.data

            if (demoType) {
                const match = DemoType.find(e => demoType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    memo: {
        name: () => '备注',
    },

    wfName: {
        name: () => '流程图名称',
        required: () => true,
    },


    wfUserCode: {
        name: () => '流程图代码',
    },
})
